import { Gestor } from "./gestor.model";

export class Assistente {
    constructor(
        public id?: number,
        public login?: string,   
        public caminhoFoto?: string,   
        public nome?: string, 
        public cpf?: string,
        public ativo?: boolean,
        public email?: string,
        public senha?: string,
        public gestor?: Gestor,
    ) { 
    }
}